import React from "react";

function Bluelocation() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
        <defs>
            <filter id="gcdgpq51ea">
                <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.129412 0 0 0 0 0.396078 0 0 0 0 0.698039 0 0 0 1.000000 0"/>
            </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g filter="url(#gcdgpq51ea)" transform="translate(-531 -258) translate(302 192) translate(16 12) translate(80 26) translate(0 28)">
                                <g>
                                    <g fillRule="nonzero" stroke="#8E8D95" strokeWidth=".8">
                                        <path d="M6.41 12.71l-.868.748-.868-.748C1.574 10.037 0 7.67 0 5.473 0 2.363 2.457 0 5.542 0c3.084 0 5.541 2.362 5.541 5.473 0 2.198-1.574 4.564-4.673 7.237z" transform="translate(133) translate(3.958 3.167)"/>
                                        <path d="M5.542 3.167c1.311 0 2.375 1.063 2.375 2.375 0 1.311-1.064 2.375-2.375 2.375-1.312 0-2.375-1.064-2.375-2.375 0-1.312 1.063-2.375 2.375-2.375z" transform="translate(133) translate(3.958 3.167)"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}

export default Bluelocation;
